// extracted by mini-css-extract-plugin
export var callCard = "_qr-0";
export var callMessageButton = "_qr-1";
export var helpIcon = "_qr-3";
export var helpIconContainer = "_qr-4";
export var verticalDivider = "_qr-2";